module.exports = __webpack_public_path__ + "news-4a753f38/error-a5fd004a6bafb6dd2b3e03b62f126df3.svg";